// extracted by mini-css-extract-plugin
module.exports = {"expandToggleBtn":"index_expandToggleBtn_2PzPk","excelDownloadBtn":"index_excelDownloadBtn_2tbaP","compare":"index_compare_1oEWH"};